import { render, staticRenderFns } from "./ExternalDynamicForm.vue?vue&type=template&id=0acbaded&"
import script from "./ExternalDynamicForm.vue?vue&type=script&lang=js&"
export * from "./ExternalDynamicForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports